import classNames from 'classnames'

import { ICON_HEIGHT_40, IconSpinner } from '../Icon'

import { usePdfViewer } from './PdfViewer.hooks'
import { PdfViewerSearchPanel } from './PdfViewerSearchPanel'
import { PdfViewerThumbnails } from './PdfViewerThumbnails'
import { PdfViewerToolbar } from './PdfViewerToolbar'

import 'pdfjs-dist/legacy/web/pdf_viewer.css'
import * as styles from './PdfViewer.module.css'

function PdfViewer({
  DocumentLoadError,
  Navigation,
  SelectAreaBox,
  className = styles.PdfViewer,
  documentLoadErrorProps,
  navigationProps,
  selectAreaBoxProps,
  onMouseDown,
  ...restProps
}) {
  const {
    containerRef,
    hasDocumentLoadError,
    isDocumentLoading,
    isPageFitMode,
    isPanMode,
    isPanning,
    isSearchOpen,
    isThumbnailsOpen,
    navigationProps: pdfNavigationProps,
    pdfDocument,
    rootRef,
    searchProps,
    selectAreaLayerRef,
    thumbnailsProps,
    toolbarProps,
    viewerElementRef,
  } = usePdfViewer(restProps)

  const withThumbnails = pdfDocument && isThumbnailsOpen

  return (
    <div className={className} ref={rootRef} onMouseDown={onMouseDown}>
      <div className={styles.documentArea}>
        {pdfDocument ? <PdfViewerToolbar {...toolbarProps} /> : null}
        <div
          className={classNames(styles.documentAreaBody, {
            [styles.withThumbnails]: withThumbnails,
          })}
        >
          {withThumbnails ? (
            <PdfViewerThumbnails
              {...thumbnailsProps}
              className={styles.thumbnailsPanel}
              pdfDocument={pdfDocument}
            />
          ) : null}
          <div className={styles.documentAreaContent}>
            {isDocumentLoading ? (
              <div className={styles.documentLoader}>
                <IconSpinner size={ICON_HEIGHT_40} />
              </div>
            ) : null}
            {hasDocumentLoadError && DocumentLoadError ? (
              <div className={styles.documentLoadError}>
                <DocumentLoadError {...documentLoadErrorProps} />
              </div>
            ) : null}
            <div
              className={classNames(styles.viewerContainer, {
                [styles.pageFitContainer]: isPageFitMode,
                [styles.panContainer]: isPanMode,
                [styles.panningContainer]: isPanning,
              })}
              ref={containerRef}
            >
              <div className='pdfViewer' ref={viewerElementRef} />
              {SelectAreaBox ? (
                <div
                  className={styles.selectAreaLayer}
                  ref={selectAreaLayerRef}
                >
                  <SelectAreaBox {...selectAreaBoxProps} />
                </div>
              ) : null}
            </div>
          </div>
          {pdfDocument && isSearchOpen ? (
            <PdfViewerSearchPanel {...searchProps} />
          ) : null}
        </div>
      </div>
      {Navigation ? (
        <Navigation {...pdfNavigationProps} {...navigationProps} />
      ) : null}
    </div>
  )
}

export default PdfViewer
